<ng-container *ngIf="canUserCrudProp">
  <button
    [disabled]="disableAddButton()"
    [matMenuTriggerFor]="menu"
    class="add-button"
    color="primary"
    mat-raised-button
  >
    <fa-icon icon="plus"></fa-icon>
    Nuevo
  </button>

  <mat-menu #menu="matMenu">
    <button
      (click)="actionClick(action.title)"
      *ngFor="let action of actions"
      [disabled]="action.canAdd"
      mat-menu-item
    >
      {{ action.title }}
    </button>
  </mat-menu>
</ng-container>
